import React from 'react';
import Section from '../../../HOC/Section';
import bgImage from '../../../assets/img/home_bg.jpg';
import Ping from '../../UI/Link/Ping';
import BLink from '../../UI/Link/Link';


const home = () => {
  return (
    <Section id='home'>
      <div>
        <div
          className='home-content p-5'
          style={{ backgroundImage: `url(${bgImage})` }}
        >
          <div className='intro container text-center text-light'>
            <h2 className='title'>The Future is Technology</h2>
            <h2 className='sub-title mb-4'>
              Find Latest Tech Jobs. Hire Seasoned Tech Talents
            </h2>
            <button className='btn btn-light rounded-0'>
              <BLink target='/latestjobs' style={{textDecoration:'none' }}>
                Tech Jobs
              </BLink>
            </button>
            <Ping target='contact' classes='btn btn-primary text-light rounded-0'>
              Tech Talents
            </Ping>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default home;
